import React, { useState } from 'react'
import SvgIcon, { iconList } from '../../../share/components/iconSVG'
import "./styles.css"

const ServicesInclude = ({ serviciosHot, serviciosHab, checkin, checkout, star }) => {

    const stars = [];

    for (let i = 0; i < Number(star); i++) {
        stars.push(<SvgIcon key={i} name={iconList.IconStar} color={'#ffff00'} size={30} />);
    }

    const [dropdownHot, setDropdownHot] = useState(false)
    const [dropdownHab, setDropdownHab] = useState(false)

    return (
        <div className='contain-services-include'>
            <div className='contain-dorpdowns'>
                <section className='contain-stars-hotel'>
                    <div className='stars-div'>
                        {
                            stars
                        }
                    </div>
                    <div className='stars-description'>
                        <span>
                            {Number(star).toFixed(1)}
                        </span>
                        <p>
                            {Number(star) === 5 ? 'Excelente' : 'Bueno'}
                        </p>
                    </div>
                </section>
                <section onClick={() => { setDropdownHot(!dropdownHot) }} className='servicios-include-dropdown'>
                    <h3>Servicios Hotel</h3>
                    {
                        dropdownHot === false ?
                            <SvgIcon name={iconList.IconArrowDown} color={"#ffffff"} size={30} />
                            :
                            <SvgIcon name={iconList.IconCloseCircleOutLine} color={"#ffffff"} size={30} />

                    }

                </section>
                {
                    dropdownHot &&

                    <ul>
                        {
                            serviciosHot === undefined ?
                                <li>
                                    <SvgIcon name={iconList.IconAlertOutLine} color={"#004274"} size={30} />
                                    No Hay Servicios Disponibles
                                </li>

                                :
                                serviciosHot.map((item, key) => {
                                    return (
                                        <li key={key}>
                                            <SvgIcon name={iconList.IconCheckSucces} color={"#004274"} size={30} />
                                            {item?.desc_serv}
                                        </li>
                                    )
                                })
                        }

                    </ul>

                }
                <section onClick={() => { setDropdownHab(!dropdownHab) }} className='servicios-include-dropdown'>
                    <h3>Servicios Habitacion</h3>
                    {
                        dropdownHab === false ?
                            <SvgIcon name={iconList.IconArrowDown} color={"#ffffff"} size={30} />
                            :
                            <SvgIcon name={iconList.IconCloseCircleOutLine} color={"#ffffff"} size={30} />

                    }
                </section>
                {
                    dropdownHab &&

                    <ul>
                        {
                            serviciosHab === undefined ?
                                <li>
                                    <SvgIcon name={iconList.IconAlertOutLine} color={"#004274"} size={30} />
                                    No Hay Servicios Disponibles
                                </li>

                                :

                                serviciosHab.map((item, key) => {
                                    return (
                                        <li key={key}>
                                            <SvgIcon name={iconList.IconCheckSucces} color={"#004274"} size={30} />
                                            {item?.descripciones}
                                        </li>
                                    )
                                })
                        }

                    </ul>

                }
            </div>
            <div className='contain-checkin'>
                <h3>Condiciones de Alojamiento</h3>
                <div className='check-in-out'>
                    <p>Hora de entrada:</p>
                    <span>A partir de {checkin}</span>
                </div>
                <div className='check-in-out'>
                    <p>Hora de Salida:</p>
                    <span>A Antes de las {checkout}</span>
                </div>
                <div className='check-in-out'>
                    <p>Desayuno:</p>
                    <span>De 7:00am a 10:00am { }</span>
                </div>
            </div>
        </div>
    )
}

export default ServicesInclude